import {
  buttonOrange,
  orangeShades,
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

/*
  The modals' plate (`Modal.styles.ts`): the same light fill and radius, and no
  border. A modal sits on a blurred backdrop and this menu has none, so the
  blur goes on the plate itself, or the page under it shows through the fill.
*/
export const accountMenuPaperStyles = {
  background: transparentColors.whiteShade3,
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  borderRadius: '0.5rem',
  border: 0,
  color: primaryColors.white,
  // MUI paints its own elevation shadow and overlay gradient otherwise.
  boxShadow: 'none',
  '--Paper-shadow': 'none',
  backgroundImage: 'none',
  minWidth: '14rem',
  // Opened upwards, so the gap to the button goes on top.
  marginTop: '-0.5rem',
  '.MuiList-root': {
    padding: '0.25rem 0'
  },
  // Deeper than MUI's `.MuiMenuItem-root + .MuiDivider-root`, which would
  // otherwise space the rule 8px off its neighbours; inset to the rows' text.
  '.MuiList-root .MuiDivider-root': {
    margin: '0.25rem 1rem'
  }
}

// The one rule in this menu, under the venue: white, as asked for, and 1px as
// a separator between rows (§2).
export const accountMenuDividerStyles = {
  borderColor: primaryColors.white
}

/*
  Answers with colour only, like the options of every other menu here. Rows
  36px apart, the sidebar's own rhythm: `icon-big` brings a 32px line height
  for a 24px glyph, which made every row 48px tall, so the icon is set solid
  and the padding supplies the rest.
*/
export const accountMenuItemStyles = {
  gap: '0.5rem',
  padding: '0.375rem 1rem',
  minHeight: 0,
  color: primaryColors.white,
  '.icon-big': {
    lineHeight: 1
  },
  '&:hover, &.Mui-focusVisible': {
    background: 'transparent',
    color: whiteShades.shade1
  },
  '&.Mui-focusVisible': {
    outline: `2px solid ${orangeShades.shade1}`,
    outlineOffset: '-2px'
  }
}

// Set apart by colour rather than by a line above it: the text button's
// orange, the one way out of the account.
export const accountMenuLogoutStyles = {
  ...accountMenuItemStyles,
  color: buttonOrange.text.font,
  '&:hover, &.Mui-focusVisible': {
    background: 'transparent',
    color: buttonOrange.text.fontHover
  },
  '&:active': {
    color: buttonOrange.text.fontActive
  }
}

// The open venue, named above the actions in white, with no icon and no
// hover: an icon is what the rows below use to say "click me", and the rule
// under the name keeps it from reading as one of them.
export const accountMenuCurrentRestaurantStyles = {
  position: 'static',
  maxWidth: '18rem',
  // With the list's own 0.25rem above it, the name stands 1rem off the top of
  // the plate, as far as it stands off the left.
  padding: '0.75rem 1rem 0.375rem',
  lineHeight: 'normal',
  textAlign: 'left',
  background: 'transparent',
  color: primaryColors.white,
  span: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}
